import { PieceSlider, PieceDescription, PieceUnorderedList } from '@store/index';
const PUBLIC_URL = process.env.REACT_APP_URL;

const healthcareInsurance = {
    name: 'healthcare Insurance',
    slug: 'healthcare-insurance',
    description: 'Application that helps healthcare insurance providers to organize consolidated healthcare insurance plans.',
    cover: {
        url: `${PUBLIC_URL}/portfolio/healthcare-insurance/cover.jpg`,
        license: {
            link: 'http://www.freepik.com',
            text: 'Designed by Freepik'
        }
    },
    prominentColor: 'rgb(225,231,227)',
    pieces: [
        {
            type: 'slider',
            images: [
                {
                    url: `${PUBLIC_URL}/portfolio/healthcare-insurance/insurance.jpg`,
                    license: {
                        link: 'http://www.freepik.com',
                        text: 'Designed by Freepik'
                    }
                },{
                    url: `${PUBLIC_URL}/portfolio/healthcare-insurance/insurance2.jpg`,
                    license: {
                        link: 'http://www.freepik.com',
                        text: 'Designed by Freepik'
                    }
                },{
                    url: `${PUBLIC_URL}/portfolio/healthcare-insurance/policy.jpg`,
                    license: {
                        link: 'http://www.freepik.com',
                        text: 'Designed by rawpixel.com / Freepik'
                    }
                },{
                    url: `${PUBLIC_URL}/portfolio/healthcare-insurance/family.jpg`,
                    license: {
                        link: 'http://www.freepik.com',
                        text: 'Designed by rawpixel.com / Freepik'
                    }
                },{
                    url: `${PUBLIC_URL}/portfolio/healthcare-insurance/cover.jpg`,
                    license: {
                        link: 'http://www.freepik.com',
                        text: 'Designed by Freepik'
                    }
                }
            ]
        } as PieceSlider,
        {
            type: 'description',
            title: 'Role',
            description: 'Full-Stack developer',
        } as PieceDescription,
        {
            type: 'unordered list',
            title: 'Main Technologies',
            items: ['Angular2', 'Node.js', 'Postgres', 'Restify', 'Sequelize', 'BI', 'Tableau'],
        } as PieceUnorderedList,
    ],
}

export default healthcareInsurance;


// WEBPACK FOOTER //
// ./src/store/portfolio/healthcare-insurance.tsx